import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyLira: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCurrencyLira"><Path d="M10 8.62891L15.5859 6.08984L16.4141 7.91016L10 10.8262V12.6289L15.5859 10.0898L16.4141 11.9102L10 14.8262V19H12C14.7614 19 17 16.7614 17 14H19C19 17.866 15.866 21 12 21H8V15.7354L5.08984 17.0586L4.26172 15.2373L8 13.5371V11.7354L5.08984 13.0586L4.26172 11.2373L8 9.53711V3H10V8.62891Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCurrencyLira;
